module.exports = __webpack_public_path__ + "img/sign.4386d777.png";